// import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import Swal from 'sweetalert2'
import api from '../service/service.js'
import VueNumeric from 'vue-numeric'
export default {
  props: ['family_id', 'id', 'ref_choice_id', 'detail', 'income', 'expenditure', 'debt', 'balance'],
  data () {
    return {
      // member_id: '',
      family_id: 0,
      step_process: '',
      // id: 0,
      // detail: '',
      // income: 0,
      // expenditure: 0,
      // debt: 0
      // balance: ''
      chioce: []
    }
  },
  components: {
    VueNumeric
  },
  methods: {
    back () {
      this.ref_choice_id = 0
      this.detail = ''
      this.income = ''
      this.expenditure = ''
      this.debt = ''
      this.balance = ''
    },
    resetval () {
      this.income = 0
      this.expenditure = 0
      this.debt = 0
    },
    setDone () {
      console.log(this.id)
      var i;
      console.log(this.ref_choice_id)
      for (i = 0; i < this.chioce.length; i++) {
        console.log(this.chioce[i].ref_choice_detail)
        if(this.ref_choice_id == this.chioce[i].ref_choice_id){
          this.detail = this.chioce[i].ref_choice_detail
          break
        }
      }
      console.log(this.detail)
      Swal.fire({
        title: 'ยืนยันการอนุมัติ?',
        text: 'บันทึกข้อมูล!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(result => {
        if (result.value) {
          console.log('asda', this.id)
          if (this.id === '0') {
            this.addIncome()
          } else {
            this.editIncome()
          }
        }
      })
    },
    addIncome () {
      let payload = {
        family_id: this.family_id,
        ref_choice_id: this.ref_choice_id,
        detail: this.detail,
        income: this.income,
        expenditure: this.expenditure,
        debt: this.debt,
        balance: this.balance
      }
      console.log('addIncomeP', payload)
      api.incomeAdd(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            $('#Modal').modal('hide')
            this.alert_msg(
              'success',
              'ข้อความจากระบบ',
              'บันทึกสำเร็จ '
            )
            this.$emit('eventVal')
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    editIncome () {
      let payload = {
        id: this.id,
        ref_choice_id: this.ref_choice_id,
        detail: this.detail,
        income: this.income,
        expenditure: this.expenditure,
        debt: this.debt,
        balance: this.balance
      }
      console.log('editIncomeP', payload)
      api.incomeEdit(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            $('#Modal').modal('hide')
            this.alert_msg(
              'success',
              'ข้อความจากระบบ',
              'บันทึกสำเร็จ '
            )
            this.$emit('eventVal')
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    calBalance () {
      this.balance = this.income - this.expenditure
      // return this.balance
    },
    // incomeById () {
    //   if (this.family_id === 0) {
    //     return
    //   }
    //   let payload = this.member_id
    //   console.log('familyById:', payload)
    //   api.memberShowById(
    //     payload,
    //     result => {
    //       console.log(result)
    //       if (result.result === true) {
    //         this.id = result.data[0].id
    //         this.detail = result.data[0].detail
    //         this.income = result.data[0].income
    //         this.expenditure = result.data[0].expenditure
    //         this.debt = result.data[0].debt
    //         this.balance = result.data[0].balance
    //         this.family_id = result.data[0].family_id
    //         this.address_number = result.data[0].address_number
    //       }
    //     },
    //     error => {
    //       alert(error)
    //       console.log(error)
    //     })
    // },
    test () {
      // console.log('Modal:member_id =' + this.member_id)
      console.log('Modal:family_id =' + this.family_id)
    },
    ChioceIncome () {
      api.incomeChioce(
        result => {
          console.log(JSON.stringify(result))
          if (result.result === true) {
            this.chioce = result.data
          }
        },
        error => {
          alert(error)
          console.log(error)
        })
    },
    senddata(val){
      console.log(val)
    }
  },
  mounted () {
    this.ChioceIncome()
    console.log('Modal:member_id =' + this.family_id)
    // this.resetval()
    // this.step_process = setInterval(() => {
    //   console.log('setInterval')
    //   if (this.member_id) {
    //     this.incomeById()
    //     clearInterval(this.step_process)
    //   }
    // }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/js/edit_income.js